import React, { useLayoutEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { filter } from "rxjs/operators";
import { Container } from "semantic-ui-react";

import { showTimeline, songsMetadata, viewingDescription } from "./atoms";

import { SHOW_PLAYLIST, commands$ } from "./CommandsStream";
import {
  FILTER,
  REORDER,
  SHOW_DESCRIPTION,
  SHOW_MOBILE_TRANSPORT,
  TOGGLE_VOLUMES,
} from "./CommandsStream";

import { PlayerModal } from "./PlayerModal";
import { mobileHeight } from "./MobileToolbar";
import { useIsMobile } from "./utils";
import { Timeline } from "./Timeline";

const descriptionCommands$ = commands$.stream.pipe(
  filter(({ action }) =>
    [FILTER, REORDER, SHOW_DESCRIPTION, SHOW_PLAYLIST, SHOW_MOBILE_TRANSPORT, TOGGLE_VOLUMES].includes(action)
  )
);

function formatDescription(html) {
  const divider = "</h1><div class='ui divider'></div>"

  return html
    .replace("</h1>", divider)
    .replaceAll("\n", "")
    .replace(/<li><p>/g, "<li>")
    .replace(/<ol>/g, "<ol style='list-style-position: inside; padding-left: 0;'>")
    .replace(/<\/p><ul>/g, "<ul style='list-style-type: none;margin-left: -2.2rem;'>")
}

function Content() {
  const isMobileDevice = useIsMobile();
  const { description } = useRecoilValue(songsMetadata);
  const withTimeline = useRecoilValue(showTimeline);

  return <div
      id="playlist-description"
      style={{
        padding: 20,
        minHeight: "100%",
        marginBottom: "3rem",
        height: isMobileDevice ? "100%" : undefined,
        animation: "fade-in-up 800ms cubic-bezier(0.19, 1, 0.22, 1) forwards",
      }}
    >
      <Container fluid >
        <div
          dangerouslySetInnerHTML={{ __html: formatDescription(description) }}
        />
      </Container>

      {withTimeline && <Timeline />}
    </div>
}

export function DescriptionModal() {
  const isMobileDevice = useIsMobile();
  const [open, setOpen] = useRecoilState(viewingDescription);

  useLayoutEffect(() => {
    const subscription = descriptionCommands$.subscribe(({ action }) => {
      if (action === SHOW_DESCRIPTION) {
        setOpen(!open);
      } else {
        setOpen(false);
      }
    });

    return () => subscription.unsubscribe();
  }, [open, setOpen]);

  const styles = isMobileDevice
    ? {
      top: 0,
      height: mobileHeight,
    }
    : undefined;

  return (
    <PlayerModal open={open} toolbar={false} visibleHeight="100%" style={styles}>
      <React.Suspense fallback={<div>Loading playlist description...</div>}>
        <Content />
      </React.Suspense>
    </PlayerModal>
  );
}
